export enum OrderType {
    None = 0,
    Mcfnet = 1,
    Facts = 2,
    Email = 3,
    ExxonMobil = 5,
    McfSap = 6,
    RpSap = 7,
    PennBatteries = 8,
    CloudSuite = 9,
    EnschedeWarehouse = 10,
    TriathlonBatteries = 11
}
